import React, { Fragment } from 'react';
import TableItem from './table-Item-SeverLog';
import { makeStyles } from "@material-ui/core/styles";
import { Typography, ListItem, Box, Grid, CircularProgress } from "@material-ui/core";
import { useTranslate, Loading } from 'react-admin';
import InfiniteScroll from 'react-infinite-scroller';
const useStyles = makeStyles(theme => ({
    root: {
        // maxWidth: 1565,
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'row',
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        marginTop: theme.spacing(1)
    },
    header: {
        // maxWidth: 1565,
        display: 'flex',
        flexDirection: 'row',
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        marginTop: theme.spacing(1),
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white
    },
    childItem: {
        display: "flex",
        alignItems: 'center',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: "ellipsis",
        maxWidth: 800
    }, Title: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: ' 0.13px',
        color: '#ffffff',
    }
}));

function Table({ hasMore, loadFunc, categories, alarmClock = false, loading }) {
    const classes = useStyles();
    const translate = useTranslate();

    return (
        <Fragment>
            <ListItem className={classes.header}>
                <Grid container>
                    <Grid item md={4}>
                        <Typography className={classes.Title}>
                            {
                                alarmClock
                                    ? translate(`resources.messageAlarm.messageAlarmTime`)
                                    : translate(`resources.severlog.Time`)
                            }</Typography>
                    </Grid>
                    <Grid item md={2}>
                        <Typography className={classes.Title}>
                            {
                                alarmClock
                                    ? translate(`resources.messageAlarm.messageAlarmEvent`)
                                    : translate(`resources.severlog.Level`)
                            }</Typography>
                    </Grid>
                    <Grid item md={4}>
                        <Typography className={classes.Title}>
                            {
                                alarmClock
                                    ? translate(`resources.messageAlarm.messageAlarmMessage`)
                                    : translate(`resources.severlog.Message`)
                            }
                        </Typography>
                    </Grid>

                </Grid>
            </ListItem>


            <div style={{ maxHeight: "80vh", overflow: 'auto' }}>
                <InfiniteScroll
                    pageStart={1}

                    loadMore={loadFunc}
                    hasMore={hasMore}
                    loader={
                        loading && <Box display='flex' justifyContent='center' width='100%'>
                            <CircularProgress></CircularProgress>
                        </Box>
                    }
                    useWindow={false}
                >
                    {
                        categories.map((item, index) =>
                            <TableItem
                                item={item}
                                classes={classes}
                                key={item.id + '-' + index}
                                alarmClock={alarmClock}
                            />

                        )
                    }
                </InfiniteScroll>

            </div>
        </Fragment>
    );

}

export default Table;
